var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Form } from "../Form";
import { SectionHeader } from "../SectionHeader";
import { Submit } from "../Submit";
import { useTranslation } from "../hooks/useTranslation";
import { FormStateStatus } from "../utils/FormStateStatus";
import { FormButtons } from "./FormButtons";
export function DetailForm(_a) {
    var values = _a.values, onSubmit = _a.onSubmit, onCancel = _a.onCancel, onEdit = _a.onEdit, children = _a.children, loading = _a.loading, title = _a.title, saveState = _a.saveState, _b = _a.isStatic, isStatic = _b === void 0 ? false : _b, errorMessage = _a.errorMessage, failedMessage = _a.failedMessage, extra = _a.extra, editDisabled = _a.editDisabled, saveDisabled = _a.saveDisabled, readOnly = _a.readOnly, messages = _a.messages, id = _a.id, tooltip = _a.tooltip, hideCancel = _a.hideCancel, submitLabel = _a.submitLabel, dataId = _a.dataId, dataTestId = _a.dataTestId;
    if (failedMessage) {
        messages = __assign(__assign({}, messages), { failed: failedMessage });
    }
    if (errorMessage) {
        messages = __assign(__assign({}, messages), { errors: errorMessage });
    }
    var t = useTranslation();
    return (React.createElement("div", { className: "detail-form", "data-id": dataId, "data-testid": dataTestId },
        React.createElement(Form, { values: values, onSubmit: onSubmit, loading: loading || saveState === "saving", isStatic: isStatic, id: id },
            React.createElement(SectionHeader, { title: "".concat(title ? "".concat(title, " ") : "").concat(t("Details")), tooltip: tooltip },
                extra && extra,
                !readOnly && (React.createElement(FormButtons, { viewState: isStatic ? "read" : "edit", onCancel: onCancel, onEdit: onEdit, saveState: saveState, id: id, editDisabled: editDisabled, hideCancel: hideCancel },
                    React.createElement(Submit, { inline: true, disabled: saveDisabled, id: id && "".concat(id, "__submit"), label: submitLabel })))),
            React.createElement(FormStateStatus, { saveState: saveState, messages: messages }),
            children)));
}
